"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortDirection = void 0;
let SortDirection;
exports.SortDirection = SortDirection;

(function (SortDirection) {
  SortDirection["Ascending"] = "Ascending";
  SortDirection["Descending"] = "Descending";
  SortDirection["None"] = "None";
})(SortDirection || (exports.SortDirection = SortDirection = {}));